import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import SeoHreflang from '../components/SeoHreflang';
import logo_rus from '../assets/logo_rus.png';
import logo_eng from '../assets/logo_eng.png';
import logo_esp from '../assets/logo_esp.png';
import logo_zh from '../assets/logo_zh.png';
import bookPartRus from '../assets/book_part_rus.pdf';
import productVideo from '../assets/product_video.mp4';
import productVideoForeign from '../assets/product_video_foreign.mp4';
import i18n from "../i18n";
import { Link } from "react-router-dom";
import SiteHeader from '../components/SiteHeader';
import VideoPlayer from "../components/VideoPlayer";
import { API_URL } from "../config";
import footerDoc1 from '../assets/footer-doc1.docx';
import footerDoc2 from '../assets/footer-doc2.docx';
const LanguageSwitcher = React.lazy(() => import('..//components/LanguageSwitcher'));


const BASE_ITEMS = [
  { type: 'link', label: 'Реестр готовых решений', path: 'registry' },
  { type: 'link', label: 'Обучение лучших практик', path: 'courses' },
  { type: 'link', label: 'Маркетплейс готовых решений', path: 'marketplace' },
  { type: 'link', label: 'Книга лучших практик', path: 'book' },
];



export default function BookPage() {
  const { t } = useTranslation();
  const { bookPrice, setBookPrice } = useState(0);

  async function fetchBookPrice() {
    try {
      const r = await fetch(`${API_URL}/settings`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await r.json();
      if (!r.ok || !data?.settings.book_price) {
        console.error('Failed to fetch book price');
      } else {
        setBookPrice(data.settings.book_price);
      }
    } catch (e) {
      console.error('Failed to fetch book price:', e);
    }
  }

  async function handleBuy() {
    try {
      const r = await fetch(`${API_URL}/book/public/book/initiate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await r.json();
      if (!r.ok || !data?.paymentUrl) {
        alert(data?.message || 'Не удалось инициализировать оплату');
        return;
      }
      window.location.href = data.paymentUrl; // банк -> SuccessURL -> сразу скачивание
    } catch (e) {
      alert('Сеть недоступна, попробуйте позже');
    }
  }

  useEffect(() => {
    fetchBookPrice();
  }, []);


/* ---------- Data ---------- */
const TOC_SECTIONS = [
  {
    title: t('BookPart1'),
    items: [
      t('BookPart11'),
      t('BookPart12'),
      t('BookPart13'),
      "...",
    ],
  },
  {
    title: t('BookPart2'),
    items: [
      t('BookPart21'),
      t('BookPart22'),
      t('BookPart23'),
      "...",
    ],
  },
  {
    title: t('BookPart3'),
    items: [
      t('BookPart31'),
      t('BookPart32'),
      t('BookPart33'),
      "...",
    ],
  },
  {
    title: t('BookPart4'),
    items: [
      t('BookPart41'),
      t('BookPart42'),
      t('BookPart43'),
      "...",
    ],
  },
  {
    title: t('BookPart5'),
    items: [
      t('BookPart51'),
      t('BookPart52'),
      t('BookPart53'),
      "...",
    ],
  },
  {
    title: t('BookPart6'),
    items: [
      t('BookPart61'),
      t('BookPart62'),
      t('BookPart63'),
      "...",
    ],
  },
  {
    title: t('BookPart7'),
    items: [
      t('BookPart71'),
      t('BookPart72'),
      t('BookPart73'),
      t('BookPart74'),
      "...",
    ],
  },
  {
    title: t('BookPart8'),
    items: [
      t('BookPart81'),
      t('BookPart82'),
      t('BookPart83'),
      "...",
    ],
  },
  {
    title: t('BookPart9'),
    items: [
      t('BookPart91'),
      t('BookPart92'),
      t('BookPart93'),
      "...",
    ],
  },
  {
    title: t('BookPart10'),
    items: [
      t('BookPart101'),
      t('BookPart102'),
      t('BookPart103'),
      "...",
    ],
  },
  {
    title: t('BookPart11'),
    items: [
      t('BookPart111'),
      t('BookPart112'),
      t('BookPart113'),
      "...",
    ],
  },
  {
    title: t('BookPart12'),
    items: [
      t('BookPart121'),
      t('BookPart122'),
      t('BookPart123'),
      t('BookPart124'),
    ],
  },
];
  const [openSample, setOpenSample] = useState(false);
  const [openVideo, setOpenVideo] = useState(false);

  const logoMap = { ru: logo_rus, en: logo_eng, es: logo_esp, zh: logo_zh };
  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
  const currentLogo = logoMap[lang] || logo_eng;


  return (
    <div className="relative min-h-screen bg-[#070810] text-[#EAEAF4] antialiased">
      <SeoHreflang />
      {/* Keyframes for floating orbs */}
      <style>{`
        @keyframes float { 0%,100% { transform: translateY(0) } 50% { transform: translateY(-24px) } }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(10px) } to { opacity: 1; transform: translateY(0) } }
      `}</style>

      {/* Background mesh */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-20"
        style={{
          backgroundImage:
            "radial-gradient(1200px 600px at 10% -10%, rgba(122,162,255,.16), transparent 60%)," +
            "radial-gradient(900px 500px at 90% 0%, rgba(124,255,203,.18), transparent 55%)," +
            "radial-gradient(1000px 800px at 50% 120%, rgba(255,157,206,.12), transparent 60%),#070810",
          filter: "saturate(115%)",
        }}
      />

      {/* Floating orbs */}
      <div
        aria-hidden
        className="fixed left-[8%] top-[20%] -z-10 h-[420px] w-[420px] rounded-full opacity-55 blur-2xl"
        style={{
          background: "radial-gradient(closest-side, rgba(124,255,203,.6), transparent)",
          animation: "float 16s ease-in-out infinite",
          filter: "blur(24px) saturate(160%)",
        }}
      />
      <div
        aria-hidden
        className="fixed right-[10%] top-[10%] -z-10 h-[520px] w-[520px] rounded-full opacity-55"
        style={{
          background: "radial-gradient(closest-side, rgba(122,162,255,.45), transparent)",
          animation: "float 16s ease-in-out infinite -4s",
          filter: "blur(24px) saturate(160%)",
        }}
      />
      <div
        aria-hidden
        className="fixed right-[20%] bottom-[4%] -z-10 h-[440px] w-[440px] rounded-full opacity-55"
        style={{
          background: "radial-gradient(closest-side, rgba(255,157,206,.48), transparent)",
          animation: "float 16s ease-in-out infinite -8s",
          filter: "blur(24px) saturate(160%)",
        }}
      />

      {/* Header */}
      <SiteHeader
        pageLinks={[
          { label: t('linkB1'), href: '#book' },
          { label: t('linkB2'), href: '#toc' },
          { label: t('linkB3'), href: '#author' },
        ]}
        bttns={[{ label: t('Button7'), handleOnClick: handleBuy }]}
        mode='dark'
      />
      {/* <header className="sticky top-0 z-50 border-b border-white/10 bg-[rgba(10,12,20,0.46)] backdrop-blur-md">
        <div className="mx-auto flex h-[72px] max-w-[1200px] items-center justify-between px-6">
          <div className="flex items-center gap-3">
            <Link to="/" style={{height: '100%'}}>
              <img src={currentLogo} style={{ height: '100%', width: 'auto' }} alt="logo"/>
            </Link>
          </div>

          <nav className="hidden gap-4 md:flex">
            <a href="#book" className="opacity-90 relative after:absolute after:left-0 after:-bottom-2 after:h-0.5 after:w-0 after:bg-[linear-gradient(90deg,#7CFFCB,#7AA2FF)] after:transition-[width] hover:after:w-full">
              {t('linkB1')}
            </a>
            <a href="#toc" className="opacity-90 relative after:absolute after:left-0 after:-bottom-2 after:h-0.5 after:w-0 after:bg-[linear-gradient(90deg,#7CFFCB,#7AA2FF)] after:transition-[width] hover:after:w-full">
              {t('linkB2')}
            </a>
            <a href="#author" className="opacity-90 relative after:absolute after:left-0 after:-bottom-2 after:h-0.5 after:w-0 after:bg-[linear-gradient(90deg,#7CFFCB,#7AA2FF)] after:transition-[width] hover:after:w-full">
              {t('linkB3')}
            </a>
            <a href="#buy" className="opacity-90 relative after:absolute after:left-0 after:-bottom-2 after:h-0.5 after:w-0 after:bg-[linear-gradient(90deg,#7CFFCB,#7AA2FF)] after:transition-[width] hover:after:w-full">
              {t('Button7')}
            </a>
          </nav>

          <a
            href="#buy"
            className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-[linear-gradient(90deg,#7CFFCB,#7AA2FF,#FF9DCE)] px-4 py-2 font-extrabold text-[#061015] shadow-[0_8px_24px_rgba(0,0,0,0.35)]"
          >
            {t('Button8')}
          </a>
          <LanguageSwitcher />
        </div>
      </header> */}

      {/* Main */}
      <main id="book" className="mx-auto max-w-[1200px] px-6">
        {/* Hero */}
        <section className="grid grid-cols-1 items-center gap-10 py-16 md:grid-cols-[1.1fr_1fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-2 font-semibold text-[#D7E9FF]">
              {t('Subheader20')}
            </span>
            <h1 className="mt-4 text-4xl leading-tight tracking-tight md:text-6xl [animation:fadeUp_.7s_ease-out_both]">
              <Trans 
              i18nKey="Header190"
              components={{ span: <span className="bg-gradient-to-r from-[#7CFFCB] via-[#7AA2FF] to-[#FF9DCE] bg-clip-text text-transparent" /> }}
              />
            </h1>
            <p className="mt-2 max-w-[720px] text-lg text-[#B2B7C7]">
              {t('Subheader21')}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <button
                onClick={handleBuy}
                className="inline-flex items-center gap-2 rounded-full border border-transparent bg-[linear-gradient(90deg,#7CFFCB,#7AA2FF,#FF9DCE)] px-4 py-3 font-extrabold text-[#061015] shadow-[0_8px_24px_rgba(0,0,0,0.35)] hover:-translate-y-px hover:shadow-[0_20px_60px_rgba(0,0,0,0.45)] transition"
              >
                {t('Button7')}
              </button>
              <a
                href={bookPartRus}
                download="01. Реализация проектов в консалтинге_RUS.pdf"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-transparent px-4 py-3 font-extrabold text-white/90 hover:-translate-y-px hover:shadow-[0_20px_60px_rgba(0,0,0,0.45)] transition"
              >
                {t('Button8')}
              </a>
              <span className="rounded-full border border-white/15 bg-white/5 px-3 py-2 text-[#B2B7C7]">
                ⭐ {t('raiting')}
              </span>
              <span className="rounded-full border border-white/15 bg-white/5 px-3 py-2 text-[#B2B7C7]">
                🎓 {t('flag1')}
              </span>
            </div>
            <div className="mt-3 flex flex-wrap gap-3">
              <span className="rounded-full border border-white/15 bg-white/5 px-3 py-2 text-[#DCE5FF]">{t('flag2')}</span>
              <span className="rounded-full border border-white/15 bg-white/5 px-3 py-2 text-[#DCE5FF]">{t('flag3')}</span>
              <span className="rounded-full border border-white/15 bg-white/5 px-3 py-2 text-[#DCE5FF]">{t('flag4')}</span>
            </div>
          </div>

          {/* Right: framed cover + play */}
          <div
            className="flex h-full relative rounded-[20px] p-[10px] shadow-[0_20px_60px_rgba(0,0,0,0.45)]"
            style={{
              border: "1px solid transparent",
            }}
          >
            <VideoPlayer videoMaterial={lang === 'ru' ? productVideo : productVideoForeign} />
          </div>
        </section>

        {/* Audience */}
        <Section title={t('Header19')} subtitle={t('Subheader22')}>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {[
              { h: t('UsefulBlockTitle1'), p: t('UsefulBlock1') },
              { h: t('UsefulBlockTitle2'), p: t('UsefulBlock2') },
              { h: t('UsefulBlockTitle3'), p: t('UsefulBlock3') },
            ].map((it) => (
              <Card key={it.h}>
                <h3 className="mb-1 text-xl font-semibold">{it.h}</h3>
                <p className="text-white/90">{it.p}</p>
              </Card>
            ))}
          </div>
        </Section>

        {/* Trusted */}
        <Section id="trusted" title={t('Header20')} subtitle={t('Subheader23')}>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-6">
            {[t('flag5'), t('flag6'), t('flag7'), t('flag8'), t('flag9'), t('flag10')].map((name) => (
              <div
                key={name}
                className="rounded-xl border border-white/15 bg-white/5 p-4 text-center text-[#DDE3F4]"
              >
                {name}
              </div>
            ))}
          </div>
        </Section>

        {/* Features */}
        <Section title={t('Header36')} subtitle={t('Subheader24')}>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            {[{
              h: t('UsefulBlockTitle4'),
              p: t('UsefulBlock4'),
              m: t('UsefulBlock42'),
            },{
              h: t('UsefulBlockTitle5'),
              p: t('UsefulBlock5'),
              m: t('UsefulBlock52'),
            },{
              h: t('UsefulBlockTitle6'),
              p: t('UsefulBlock6'),
              m: t('UsefulBlock62'),
            }].map((it) => (
              <Card key={it.h}>
                <h3 className="mb-1 text-xl font-semibold">{it.h}</h3>
                <p className="text-white/90">{it.p}</p>
                <div className="mt-2 text-sm text-[#B2B7C7]">{it.m}</div>
              </Card>
            ))}
          </div>
        </Section>

        {/* TOC + side card */}
        <section id="toc" className="border-t border-white/10 py-14">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-[1.2fr_1fr]">
            <div>
              <h2 className="mb-2 text-3xl font-semibold tracking-tight">{t('Header22')}</h2>
              <p className="mb-4 max-w-[820px] text-[#B2B7C7]">{t('Subheader25')}</p>

              {TOC_SECTIONS.map((s) => (
                <details key={s.title} className="mb-2 rounded-xl border border-white/15 bg-white/5 p-3">
                  <summary className="cursor-pointer font-extrabold">{s.title}</summary>
                  <ul className="ml-6 list-disc space-y-1 pt-2 text-white/90">
                    {s.items.map((li) => (
                      <li key={li}>{li}</li>
                    ))}
                  </ul>
                </details>
              ))}
            </div>

            <Card>
              <h3 className="mb-2 text-xl font-semibold">{t('UsefulBlock7')}</h3>
              <ul className="ml-6 list-disc space-y-1 text-white/90">
                <li>{t('UsefulBlock71')}</li>
                <li>{t('UsefulBlock72')}</li>
                <li>{t('UsefulBlock73')}</li>
                <li>{t('UsefulBlock74')}</li>
              </ul>
              <div className="mt-3 text-sm text-[#B2B7C7]">
                {t('UsefulBlock75')}
              </div>
            </Card>
          </div>
        </section>

        {/* Author */}
        <Section id="author" title={t('Header23')}>
          <div className="grid grid-cols-1 items-center gap-5 md:grid-cols-[160px_1fr]">
            <div
              role="img"
              aria-label="Фото автора"
              className="h-[160px] w-[160px] rounded-2xl"
              style={{
                background:
                  "conic-gradient(from 200deg, #d3e5ff, #aaffec, #ffc2e0, #d3e5ff)",
              }}
            />
            <Card className="!p-5">
              <h3 className="mb-2 text-xl font-semibold">
                {t('Subheader26')}
              </h3>
              <p className="text-white/90">
                {t('Subheader261')}
              </p>
              <div className="mt-2 text-sm text-[#B2B7C7]">🎤 HSE • 📚 РИНЦ • 🌍 KDP</div>
            </Card>
          </div>
        </Section>

        {/* Reviews */}
        <Section id="praise" title={t('Header30')} subtitle={t('Subheader27')}>
          <div className="grid auto-cols-[minmax(0,1fr)] grid-flow-col gap-4 overflow-x-auto pb-2">
            {[
              t('Subheader271'),
              t('Subheader272'),
              t('Subheader273'),
            ].map((q, i) => (
              <div key={i} className="rounded-2xl border border-white/15 bg-white/5 p-4">
                “{q}”
              </div>
            ))}
          </div>
        </Section>

        {/* Pricing */}
        <Section id="buy" title={t('Header25')} subtitle={t('Subheader28')}>
          <div className="grid justify-center">
            <div className="mx-auto max-w-[340px] text-center">
              <div
                className="rounded-2xl border-2 border-transparent bg-[#0b0f18] p-6 shadow-[0_0_25px_rgba(124,255,203,.25)]"
                style={{
                  backgroundImage:
                    "linear-gradient(#0b0f18,#0b0f18),linear-gradient(90deg,#7CFFCB,#7AA2FF,#FF9DCE)",
                  backgroundOrigin: "border-box",
                  backgroundClip: "padding-box,border-box",
                }}
              >
                <div className="text-[12px] uppercase tracking-[.16em] text-[#9db4ff]">E‑book</div>
                <div className="mt-1 inline-block rounded-full border border-transparent bg-[linear-gradient(90deg,#7CFFCB,#7AA2FF)] px-3 py-1 font-bold text-[#061015]">
                  {t('Subheader281')}
                </div>
                <div className="my-2 bg-gradient-to-r from-[#7CFFCB] to-[#7AA2FF] bg-clip-text text-5xl font-black text-transparent">
                  {bookPrice} ₽
                </div>
                <p className="mb-4 text-white/90">{t('Subheader29')}</p>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 rounded-full border border-transparent bg-[linear-gradient(90deg,#7CFFCB,#7AA2FF,#FF9DCE)] px-4 py-3 font-extrabold text-[#061015] shadow-[0_8px_24px_rgba(0,0,0,0.35)]"
                >
                  {t('Button9')}
                </a>
              </div>
            </div>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {["Amazon KDP", "IngramSpark", "Lulu", "Draft2Digital"].map((r) => (
              <span key={r} className="rounded-full border border-white/15 bg-white/5 px-3 py-2 text-[#DCE5FF]">
                {r}
              </span>
            ))}
          </div>
        </Section>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-10 text-[#B2B7C7]">
        <div className="mx-auto max-w-[1200px] px-6">
          <p>
          © 2025 Best Practices Press
          </p>
          <a href={footerDoc2} download={`${t('$UserAgr')}.docx`} style={{textDecoration: 'none', color: 'black'}}>
              <p>
                  {t('$UserAgr')}
              </p>
          </a>
          <a href={footerDoc1} download={`${t('$Pol')}.docx`} style={{textDecoration: 'none', color: 'black'}}>
              <p>
                  {t('$Pol')}
              </p>
          </a>
        </div>
      </footer>

      {/* Sample modal */}
      {openSample && (
        <Modal onClose={() => setOpenSample(false)} title="Фрагмент книги (PDF, 20 стр.)">
          <p className="text-white/90">Здесь будет предпросмотр PDF или ссылка на скачивание.</p>
        </Modal>
      )}

      {/* Video modal */}
      {openVideo && (
        <Modal onClose={() => setOpenVideo(false)} title="Демо‑видео">
          <div className="relative w-full overflow-hidden rounded-xl border border-white/10 bg-[#0b0f18] pt-[56.25%]">
            <iframe
              title="Демо"
              src=""
              allow="autoplay; encrypted-media"
              allowFullScreen
              className="absolute inset-0 h-full w-full rounded-xl border-0"
            />
          </div>
        </Modal>
      )}
    </div>
  );
}

/* ---------- Small building blocks ---------- */
function Section({ id, title, subtitle, children }) {
  return (
    <section id={id} className="border-t border-white/10 py-14">
      <h2 className="mb-1 text-3xl font-semibold tracking-tight">{title}</h2>
      {subtitle && <p className="mb-4 max-w-[820px] text-[#B2B7C7]">{subtitle}</p>}
      {children}
    </section>
  );
}

function Card({ className = "", children }) {
  return (
    <div className={`rounded-2xl border border-white/15 bg-white/5 p-6 ${className}`}>{children}</div>
  );
}

function Modal({ title, children, onClose }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[60] grid place-items-center p-4"
    >
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-[880px] overflow-hidden rounded-2xl border border-white/10 bg-[#0f1117] text-[#e8eaf0] shadow-[0_15px_60px_rgba(0,0,0,.6)]">
        <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
          <b>{title}</b>
          <button onClick={onClose} className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2">
            Закрыть
          </button>
        </div>
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
